import { render, staticRenderFns } from "./exam-detail.vue?vue&type=template&id=4555f1c3&scoped=true&"
import script from "./exam-detail.vue?vue&type=script&lang=js&"
export * from "./exam-detail.vue?vue&type=script&lang=js&"
import style0 from "./exam-detail.vue?vue&type=style&index=0&id=4555f1c3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555f1c3",
  null
  
)

export default component.exports